//
import RDialog from '../crud-dialog'
import RForm from '../model-form'
import RDialogAdder from '../Dialogs/AdderDialog'

//
export default {
    components: {
        'crud-data-table-dialog-picker': () =>
            import('../CrudDataTableDialogPicker'),
        RDialog,
        RDialogAdder,
        RForm,
    },
    computed: {

        /**
         * export item props
         */
        exportProps() {
            return {
                // disabled: this.disabled && !this.alwaysExport,
            }
        },

        /**
         * helper item props
         */
        filterProps() {
            return {
                dark: this.value.filtering && !this.disabled,
                depressed: this.value.filtering,
                disabled: this.disabled,
            }
        },

        /**
         * @description
         * { function_description }
         *
         * @return  {Object}    { description_of_the_return_value }
         */
        headsProps() {
            return {
                width: 720,
            }
        },

        /**
         * helper item props
         */
        helperProps() {
            return {
                dark: this.value.helping,
                depressed: this.value.helping,
                disabled: this.disabled,
            }
        },

        /**
         * items props
         */
        itemsProps() {
            return {
                disabled: this.disabled,
            }
        },

        /**
         * refresh item props
         */
        refreshProps() {
            return {
                disabled: this.disabled,
                loading: this.disabled,
            }
        },

        /**
         * { function_description }
         *
         * @return     {Object}  { description_of_the_return_value }
         */
        searchProps() {
            return {
                clearable: ! this.dense,
                disabled: this.disabled,
                placeholder: this.searchPlaceholder,
                outline: ! this.dense,
                solo: this.dense,
            }
        },

        /**
         * can show helper item
         */
        showExport() {
            return !this.noExport
        },

        /**
         * can show filter item
         */
        showFilter() {
            return !this.noFilter
        },

        showHeads() {
            return this.heads
        },

        /**
         * can show helper item
         */
        showHelper() {
            return !this.noHelper
        },

        /**
         * can show refresh item
         */
        showRefresh() {
            return !this.showPicker && !this.noRefresh
        },

        /**
         * can show search box
         */
        showSearch() {
            return this.title ? !this.noSearch && !this.disabled : !this.noSearch
        },

        /**
         *  toolbar props
         */
        toolbarProps() {
            return {
                color: this.color,
                dark: this.dark,
                height: this.dense ? 56 : 96,
            }
        },
    },
    data() {
        return {
            adder: false,
            heads: false,
            modal: false,
            search: '',
        }
    },
    methods: {
        /**
         * set the filtering boolean value
         */
        setFiltering(val = false) {
            this.value.filtering = Boolean(val)
        },

        /**
         * set the helping boolean value
         */
        setHelping(val = false) {
            this.value.helping = Boolean(val)
        },

        /**
         * set the search string value
         */
        setSearch(val = '') {
            this.$emit('input', {
                ...this.value,
                search: val,
            })
            this.$emit('search')
            //this.value.search = String(val)
        },

        /**
         * @description
         * success adder emitter
         */
        successAdder(event) {
            return this.$emit('added', event)
        },

        /**
         * set the modal boolean value
         */
        submitAdd() {
            this.modal = true
        },

        /**
         * set the empty search string value
         */
        submitClear() {
            this.setSearch('')
        },

        /**
         * emit the export event
         */
        submitExport() {
            this.$emit('excel')
        },

        /**
         * toggle the filtering boolean value
         */
        submitFiltering() {
            this.setFiltering(!this.value.filtering)
        },

        /**
         * @description
         * { function_description }
         */
        submitHeads() {
            this.heads ^= 1
        },

        /**
         * toggle the helping boolean value
         */
        submitHelping() {
            this.setHelping(!this.value.helping)
        },

        /**
         * emit the picker event
         */
        submitPicker(event) {
            this.$emit('picker', event)
        },

        /**
         * emit the refresh event
         */
        submitRefresh() {
            this.$emit('refresh')
        },

        /**
         * emit the refresh event
         */
        submitColumnSelect() {
            this.$emit('column:select')
        },

        /**
         * emit the remove event
         */
        submitRemove() {
            this.$emit('remove')
        },

        /**
         * set the search value with the current search data
         */
        submitSearch() {
            this.syncSearch()
        },

        /**
         * @description
         * show adder dialog
         */
        submitNew() {
            this.adder = true
        },

        /**
         * sync the search value with the current search data
         */
        syncSearch() {
            this.setSearch(this.search)
        },
    },
    props: {
        /**
         *
         */
        adderProps: {
            type: Object,
            default: () => ({}),
        },

        /**
         * 
         */
        alwaysExport: {
            type: Boolean,
        },

        /**
         * toolbar color
         */
        color: {
            type: String,
            color: 'white',
        },

        /**
         * toolbar dark theme flag
         */
        dark: Boolean,

        /**
         * toolbar dense height flag
         */
        dense: Boolean,

        /**
         * toolbar disabled
         */
        disabled: Boolean,

        /**
         * Show the filter length
         */
        filterLength: Number,

        /**
         * show export item flag
         */
        noExport: Boolean,

        /**
         * show filter item flag
         */
        noFilter: Boolean,

        /**
         * show helper item flag
         */
        noHelper: Boolean,

        /**
         * hide refresh option
         */
        noRefresh: Boolean,

        /**
         * show search box flag
         */
        noSearch: Boolean,

        /**
         * picker dialog props
         */
        pickerProps: {
            type: Object,
            default: () => ({}),
        },

        /**
         * search placeholder
         */
        searchPlaceholder: {
            type: String,
            default: 'Escriba un valor para buscar...',
        },

        /**
         * show picker dialog flag
         */
        showPicker: Boolean,

        /**
         * @description
         * show adder dialog flag
         */
        showAdder: Boolean,

        /**
         * show remove button
         */
        showRemove: Boolean,

        /**
         * show column select button
         */
        showColumnSelect: Boolean,

        /**
         * toolbar title
         */
        title: String,

        /**
         * filter & helper value flags
         */
        value: {
            type: Object,
            default: () => ({
                filtering: false,
                helping: false,
            }),
        },
    },
    watch: {
        /**
         * @description
         * watch adder flag
         */
        adder() {
            //console.log('adder', this.adder)
        },
    },
}
